import type { LoginAuthWebResponse } from "../../../../generated/grpc/login_pb";
import { BaseLoginResponse } from "../../../../base/response/BaseLoginResponse";

/** Mapea la response proto de `LoginService` a la misma forma que ya devuelve
 *  REST (`Dto.Seguridad.Response.LoginAuthWebResponse` del servidor,
 *  `LoginAuthResponse` del lado cliente). La usan tanto
 *  `LoginByEmailPasswordGrpcService` como `LoginByTokenGrpcService`: los dos
 *  rpcs de `LoginService` devuelven el mismo mensaje. Piloto real de la
 *  migración a gRPC-Web, ver CLAUDE.md. */
export function mapGrpcLoginResponse<TResponse extends BaseLoginResponse>(
  response: LoginAuthWebResponse,
): TResponse {
  return {
    token: response.token,
    nombre: response.nombre,
    clienteId: response.clienteId,
    maximoHectareas: response.maximoHectareas,
    isDemoPlataforma: response.isDemoPlataforma,
    fechaVencimientoPlataforma:
      response.fechaVencimientoPlataforma !== undefined ? Number(response.fechaVencimientoPlataforma) : null,
  } as unknown as TResponse;
}
